import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import { getRenewalRequestDetails } from "services/redux/contractRenewal/action";
import RaisedRequestsList from "./raisedRequestsList";

const mapStateToProps = (state) => ({
  requestDetails: state.contractRenewalReducer.requestDetails
});

const mapDispatchToProps = (dispatch) =>
  bindActionCreators(
    {
      getRenewalRequestDetails
    },
    dispatch
  );

export default connect(mapStateToProps, mapDispatchToProps)(RaisedRequestsList);
